
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import {
    CELLTIPO_CADENA,
    CELLTIPO_ENTERO,
    CELLTIPO_FOREIGN,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import {CAMPOTIPO_CADENA, CAMPOTIPO_HTMLMEMO} from "../../framework2/ej2/UI/TiposCampos";
import Formulario from "../../framework2/ej2/UI/Formulario";
import {getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";
import {BOTONERA_REFRESCAR} from "../../framework2/ej2/UI/FormularioBotonera";

class Consentimientotipos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
        }

        this.generarGridConfig(props);
        this.generarElementoConfig(props);
    }

    componentDidMount() {

    }

    generarGridConfig= (props) => {
        this.gridConfig = getGridConfigNombre("Consentimientotipo");
        this.gridConfig.ordenInicial=[{nombreCampo:"nombre", asc:true}];
        this.gridConfig.editable= true;
    }

    generarElementoConfig= (props) => {
        this.elementoConfig= getElementoConfigNombre("Consentimientotipo");
        this.elementoConfig.campos.push(
            {campo:"texto", titulo: "Texto", tipo: CAMPOTIPO_HTMLMEMO, cols: 12, height: 260},
        );
    }



    render() {
        return (
            <div>
                <Formulario icon="office" titulo="Tipos de consentimientos"
                            gridConfig={this.gridConfig}
                            elementoConfig={this.elementoConfig}
                />
            </div>
        )
    }

}

Consentimientotipos.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Consentimientotipos);



